import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';

export default function Layout({ darkMode: initialDarkMode }) {
  const [darkMode, setDarkMode] = useState(() => {
    const savedMode = localStorage.getItem('darkMode');
    return savedMode !== null ? savedMode === 'true' : initialDarkMode;
  });

  useEffect(() => {
    localStorage.setItem('darkMode', darkMode);
  }, [darkMode]);

  const handleDarkModeToggle = () => {
    setDarkMode(prev => !prev);
  };

  return (
    <div className={`${darkMode ? 'cs_dark' : ''}`}>
      <Header
        logoUrl={darkMode ? '/images/logo_white.svg' : '/images/logo.svg'}
        actionBtnText="Getting Started"
        actionBtnUrl="/contact"
        darkMode={darkMode}
        onDarkModeToggle={handleDarkModeToggle}
      />
      <Outlet />
      <Footer />
    </div>
  );
}
